<template>
  <div>
    <b-button
      v-if="
        showFlugstammdatenButton &&
        aufgabenKategorie !== 'TeilnehmendeOhneTransferplanung' &&
        aufgabenKategorie !== 'Terminplanung'
      "
      class="ml-auto d-flex justify-content-center align-items-center p-2"
      @click="openFilteredFlugstammdatenView"
    >
      Gehe zu Flugstammdaten
    </b-button>

    <b-button
      v-if="aufgabenKategorie === 'AnlageHotelstamm'"
      class="ml-auto d-flex justify-content-center align-items-center p-2"
      @click="openFilteredReiseterminplanungView"
    >
      Gehe zu Reiseterminplanung
    </b-button>

    <b-button
      v-if="isTerminplanungAufgabe"
      class="ml-auto d-flex justify-content-center align-items-center p-2"
      @click="openTerminplanungView"
    >
      Gehe zur Terminplanung
    </b-button>
    <h6 class="ml-auto" v-if="aufgabenKategorie === 'GruppeneinkaufPruefen'">
      <a :href="'#/reisetermine/flugplanung?reiseterminkuerzel=' + joinedReiseterminkuerzel" target="_blank">
        <ExternalLink :size="20" />
        Reisetermine in der Flugplanung
      </a>
    </h6>
    <b-table
      :items="sortedReiseterminData"
      :fields="verlinkungenFields"
      responsive
      hover
      style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: 5px; margin-top: 12px"
      head-variant="light"
      @row-clicked="rowClicked"
    >
      <template v-slot:cell(reiseterminkuerzel)="row">
        <div style="width: 180px; display: flex; flex-direction: row; gap: 0.8rem">
          <div v-if="row.item.ursprungsreiseterminId" style="cursor: pointer">
            <a
              target="_blank"
              :href="'/#/reisetermine/' + row.item.ursprungsreiseterminId"
              v-b-tooltip.hover
              title="Ursprungstermin"
            >
              <CalendarMinus :size="20" />
            </a>
          </div>
          <div v-if="row.item.ersatztermin" style="cursor: pointer">
            <a
              target="_blank"
              :href="'/#/reisetermine/' + row.item.ersatztermin.id"
              v-b-tooltip.hover
              title="Ersatztermin"
            >
              <CalendarCheck :size="20" />
            </a>
          </div>

          {{ row.item.reiseterminkuerzel }}
        </div>
      </template>
      <template v-slot:cell(releasefrist)="data">
        <span v-html="data.value"></span>
      </template>

      <template v-slot:cell(actionsRTDetailUndFlugplanung)="row">
        <div class="d-flex" style="gap: 5px">
          <a
            class="kachel-badge kachel-badge--square gray text-decoration-none"
            :href="'/#/reisetermine/' + row.item.id + '?vorgangdetailstab=fluege&scrollToFlugdaten=true'"
            target="_blank"
          >
            RT
          </a>
          <a
            class="kachel-badge kachel-badge--square gray text-decoration-none"
            :href="'/#/reisetermine/flugplanung?reisetermine=' + row.item.reiseterminkuerzel.substring(0, 6)"
            target="_blank"
          >
            FP
          </a>
        </div>
      </template>

      <template v-slot:cell(actionsRTDetail)="row">
        <div class="d-flex" style="gap: 5px">
          <a
            class="kachel-badge kachel-badge--square gray text-decoration-none"
            :href="'/#/reisetermine/' + row.item.id + '?vorgangdetailstab=fluege&scrollToFlugdaten=true'"
            target="_blank"
          >
            RT
          </a>
        </div>
      </template>

      <template v-slot:cell(state)="row">
        <ReiseterminStateBadge :state="row.item.state" feste-breite />
      </template>
      <!-- releaseprozessStatus wird je Zeile nachgeladen -->
      <template v-slot:cell(releaseprozessStatus.teilnehmerdatenStatus)="row">
        <UserCheck
          :size="20"
          :class="releaseprozessIconsColors(row.item.releaseprozessStatus?.teilnehmerdatenStatus)"
        />
      </template>
      <template v-slot:cell(releaseprozessStatus.reiseleistungListenversandStatus)="row">
        <Luggage
          :size="20"
          :class="releaseprozessIconsColors(row.item.releaseprozessStatus?.reiseleistungListenversandStatus)"
        />
      </template>
      <template v-slot:cell(releaseprozessStatus.fluegeStatus)="row">
        <Plane :size="20" :class="releaseprozessIconsColors(row.item.releaseprozessStatus?.fluegeStatus)" />
      </template>
      <template v-slot:cell(releaseprozessStatus.transferplanungStatus)="row">
        <Car
          :size="20"
          :class="releaseprozessIconsColors(row.item.releaseprozessStatus?.transferplanungStatus)"
        />
      </template>
      <template v-slot:cell(hotelsUndProgrammGeprueft)="row">
        <ClipboardList
          :size="20"
          :class="row.item.hotelsUndProgrammGeprueft ? 'text-success' : 'text-danger'"
        />
      </template>
      <template v-slot:cell(transferplanungGeprueft)="row">
        <Bus :size="20" :class="row.item.transferplanungGeprueft ? 'text-success' : 'text-danger'" />
      </template>
      <template v-slot:cell(garantiert)="row">
        <CustomIconChecked :value="row.item.garantiert" />
      </template>

      <template v-slot:cell(vorzeitigGarantiert)="row">
        <CustomIconVorzeitigGarantiert :value="row.item.vorzeitigGarantiert" />
      </template>

      <template v-slot:cell(reise.isKritischeDestination)="row">
        <CustomIconChecked
          v-if="row.item.reise.isKritischeDestination !== null"
          :value="row.item.reise.isKritischeDestination"
        />
        <div v-else>-</div>
      </template>
      <template v-slot:cell(metadata.releasefrist)="row">
        <CircleCheck v-if="row.item.metadata?.releasefrist?.length > 1" :size="20" class="text-success" />
        <CircleX v-else :size="20" class="text-danger" />
      </template>
      <template v-slot:cell(commentCount)="row">
        <span>{{ row.item.comments.length }}</span>
      </template>
      <template v-slot:cell(aufgaben)="row">
        <b-badge :id="'tooltip-target-reisetermin' + row.item.id">
          {{ row.item.aufgaben?.length }}
        </b-badge>
        <b-tooltip
          :target="'tooltip-target-reisetermin' + row.item.id"
          triggers="hover"
          custom-class="custom-tooltip"
          v-if="row.item.aufgaben?.length > 1"
        >
          <AufgabenWidget
            :openAufgabenId="openAufgabenId"
            class="mt-3"
            :ansicht="'aufgabe-details'"
            :aufgaben="row.item.aufgaben || []"
          ></AufgabenWidget>
        </b-tooltip>
      </template>
      <template v-slot:cell(paxWidget)="row">
        <PaxWidget
          :paxObject="row.item.pax"
          :minPax="row.item.metadata?.minPax"
          :maxPax="row.item.metadata?.maxPax"
          :kalkPax="row.item.metadata?.kalkPax"
          :forecastPax="row.item.metadata?.forecastPax"
          :durchfuehrbareMinPax="row.item.metadata?.durchfuehrbareMinPax"
        ></PaxWidget>
      </template>
      <template v-slot:cell(reise.prioritaet)="data">
        <PrioritaetWidget :prioritaet="data.value"></PrioritaetWidget>
      </template>
      <template v-slot:cell(zimmerkontingenteWidget)="row">
        <ZimmerkontingenteWidget
          :zimmerkontingente="row.item?.zimmerkontingente"
          :reiseterminId="row.item?.id"
          :isZvc="true"
        ></ZimmerkontingenteWidget>
      </template>
      <template v-slot:cell(planZimmerkontingenteWidget)="row">
        <ZimmerkontingenteWidget
          :zimmerkontingente="row.item?.metadata?.planZimmerkontingente"
          :reiseterminId="row.item?.id"
          :isPlan="true"
        ></ZimmerkontingenteWidget>
      </template>
      <template v-slot:cell(nochErwartetePax)="row">
        <span class="kachel-badge" :class="nochErwartetePaxVariant(row.item)">
          {{ row.item.nochErwartetePax }}
        </span>
      </template>
      <template v-slot:cell(paxBisMax)="row">
        <span class="kachel-badge" :class="paxBisMaxVariant(row.item)">
          {{ row.item.paxBisMax }}
        </span>
      </template>
      <template v-slot:cell(nochForecastPax)="row">
        <span class="kachel-badge" :class="nochForecastPaxVariant(row.item)">
          {{ row.item.nochForecastPax }}
        </span>
      </template>

      <template v-slot:cell(reisezeitraum)="row">
        <div style="width: 150px">
          {{ formatDateWithoutHours(row.item.abreisedatum) }} -
          {{ formatDateWithoutHours(row.item.enddatum) }}
        </div>
      </template>
      <template v-slot:cell(ziellandZielUndAblugflughafen)="row">
        {{ row.item.metadata?.ziellandZielflughaefen?.map(fh => fh.flughafenIataCode).join(', ') }} /
        {{ row.item.metadata?.ziellandAbflughaefen?.map(fh => fh.flughafenIataCode).join(', ') }}
      </template>
      <template v-slot:cell(TSHinUndRueck)="row">
        {{ formatTransferSzenario(row.item.metadata?.transferszenarioHin) }}
        /
        {{ formatTransferSzenario(row.item.metadata?.transferszenarioRueck) }}
      </template>

      <template v-slot:cell(metadata.hotelstartVorLandung)="row">
        <CustomIconChecked :value="row.item.metadata?.hotelstartVorLandung" />
      </template>
      <template v-slot:cell(metadata.rueckflugNachHotelende)="row">
        <CustomIconChecked :value="row.item.metadata?.rueckflugNachHotelende" />
      </template>
      <template v-slot:cell(abgesagt)="row">
        <CustomIconChecked :value="row.item.abgesagt" />
      </template>
      <template v-slot:cell(stopSale)="row">
        <CustomIconExclamation :value="row.item.stopSale" />
      </template>
      <template v-slot:cell(inlandsflugEinkauf)="row">
        <span
          v-if="inlandsflugEinkaufState(row.item) === 'skr'"
          class="text-danger"
          v-b-tooltip.hover
          title="Nur SKR Inlandsflüge"
        >
          <Plane :size="20" />
        </span>
        <span
          v-if="inlandsflugEinkaufState(row.item) === 'dmc'"
          style="color: #000"
          v-b-tooltip.hover
          title="Nur DMC Inlandsflüge"
        >
          <Plane :size="20" />
        </span>
        <span
          v-if="inlandsflugEinkaufState(row.item) === 'mixed'"
          style="color: #a6a6a8"
          v-b-tooltip.hover
          title="Gemischte Inlandsflüge"
        >
          <Plane :size="20" />
        </span>
      </template>
      <template v-slot:cell(flugeinkaufEinkaufsart)="row">
        <span>{{ translateEinkaufsartOptions(row.item?.flugeinkauf?.einkaufsart) }}</span>
      </template>
      <template v-slot:cell(flugeinkaufStatusgruppe)="row">
        <span>{{ translateStatusGruppeOptions(row.item?.flugeinkauf?.statusgruppe) }}</span>
      </template>
      <template v-slot:cell(flugeinkaufGruppeFlughafen)="row">
        <span>{{ getGruppeFlughaefen(row.item) }}</span>
      </template>
      <template v-slot:cell(flugeinkaufErsteGruppeFlughafen)="row">
        <span>{{ getErsteGruppeFlughaefen(row.item) }}</span>
      </template>
      <template v-slot:cell(flugeinkaufErsteGruppeGesamtpreis)="row">
        <span>{{ getErsteGruppeGesamtpreis(row.item) }}</span>
      </template>
      <template v-slot:cell(benoetigteDokumente)="row">
        <span>{{ getRequiredDokumente(row.item?.gueltigeKonfiguration) }}</span>
      </template>
      <template v-slot:cell(flugverfuegbarkeiten)="row">
        <div style="width: 350px; display: flex; justify-content: center">
          <FlugverfuegbarkeitenWidget
            :flugverfuegbarkeiten="row.item.flugverfuegbarkeiten ?? []"
            :data="row.item"
          ></FlugverfuegbarkeitenWidget>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import ZimmerkontingenteWidget from '@/components/common/zimmerkontingente/zimmerkontingente-widget.vue';
import AufgabenWidget from '@/components/produkte/reisetermine/aufgaben-widget.vue';
import PaxWidget from '@/components/produkte/reisetermine/pax-widget.vue';
import FlugverfuegbarkeitenWidget from '@/components/produkte/reisetermine/flugverfuegbarkeiten-widget.vue';

import currenciesJson from '@/core/common/helpers/currencies.json';
import PrioritaetWidget from '@/components/common/prioritaet-widget.vue';
import CustomIconChecked from '@/components/common/custom-icon-checked.vue';
import CustomIconVorzeitigGarantiert from '@/components/common/custom-icon-vorzeitig-garantiert.vue';
import CustomIconExclamation from '@/components/common/custom-icon-exclamation.vue';
import ReiseterminStateBadge from '@/components/produkte/reisetermine/reisetermin-state-badge.vue';

import { mapGetters } from 'vuex';

import {
  formatDateWithoutHours,
  translateEinkaufsartOptions,
  translateStatusGruppeOptions,
  releaseprozessIconsColors,
} from '@/core/common/helpers/utils';
import {
  Bus,
  CalendarCheck,
  CalendarMinus,
  Car,
  CircleCheck,
  ClipboardList,
  ExternalLink,
  Luggage,
  Plane,
  UserCheck,
  CircleX,
} from 'lucide-vue';

import {
  zvcVerlinkungenFields,
  fomVerlinkungenFields,
  releaseprozessVerlinkungenFields,
  basicVerlinkungenFields,
  fieldsGruppeneinkaufPruefen,
  fieldsAnlageFlugstamm,
  fieldsAnlageHotelstamm,
  fieldsOptionsfristErreicht,
  fieldsStopsaleSetzen,
  teilnehmerdokumenteVerlinkungenFields,
  kurzesTktlFields,
  minMaxPaxPruefenFields,
  fieldsVorabpruefungTicketBeiGruppe,
  fieldsZTVTGPruefen,
  TicketingAnfrageVerlinkungenFields,
  repruAufgabenFields,
  fomUnverbindlichesFlugangebotVerlinkungenFields,
  fieldsTerminplanungAufgaben,
} from '@/core/common/helpers/verlinkungen-config';
import { FOM_KATEGORIEN } from '@/core/common/helpers/aufgaben-kategorien';

const ZVC_KATEGORIEN = [
  'ZimmerkontingentePruefenMaxPax',
  'ZimmerkontingentePruefenErwartetePax',
  'MaxPaxEzPruefen',
];

const TERMINPLANUNG_KATEGORIEN = [
  'Terminfreigabe',
  'AnlagePruefen',
  'ProgrammaenderungPruefen',
  'KontingentaenderungPruefen',
  'Planueberpruefung',
  'TerminalternativenPruefen',
  'TerminbestaetigungEinholen',
];

const RELEASEPRUEFUNG_KATEGORIEN = ['MtzErreicht', 'FehlendePassdaten', 'TeilnehmerdokumentePruefen'];

const RELEASEPROZESS_FIELDS_KATEGORIEN = [
  'FehlendePassdaten',
  'PreTransferlisteAnDomSenden',
  'GarantiePruefen',
  'AfrikaFahrzeugplanung',
  'HotelwechselPruefen',
  'HotellisteAnpassen',
];

const OPTIONSFRIST_KATEGORIEN = [
  'OptionsfristErreicht',
  'GruppeFlugplanung',
  'GruppeTerminabsageOderVerschiebung',
  'FlugeinkaufsartFestlegen',
];

const KURZES_TKTL_KATEGORIEN = ['KurzesTktlFreischalten', 'KurzesTktlDeaktivieren', 'ResGeplantErsetzen'];

const DOKUMENT_FIELDS = {
  versicherungsnachweisRequired: 'Versicherungsnachweis',
  verzichtserklaerungRequired: 'Verzichtserklärung',
  loiAntragRequired: 'LOI Antrag',
  referenznummerAntragRequired: 'Referenznummer',
};

export default {
  components: {
    ZimmerkontingenteWidget,
    ReiseterminStateBadge,
    AufgabenWidget,
    FlugverfuegbarkeitenWidget,
    PaxWidget,
    PrioritaetWidget,
    CustomIconChecked,
    CustomIconVorzeitigGarantiert,
    CustomIconExclamation,
    Bus,
    CalendarCheck,
    CalendarMinus,
    Car,
    CircleCheck,
    ClipboardList,
    ExternalLink,
    Luggage,
    Plane,
    UserCheck,
    CircleX,
  },
  props: {
    reiseterminData: { type: Array, required: true },
    aufgabenKategorie: { type: String, required: true },
    isRepruAufgabe: { type: Boolean, default: false },
    openAufgabenId: { type: Number, default: null },
  },
  computed: {
    ...mapGetters(['getKategorienReleaseprozess']),

    // Sortiert die Reisetermine nach Abreisedatum (aufsteigend).
    sortedReiseterminData() {
      if (!this.reiseterminData) return [];
      return [...this.reiseterminData].sort((a, b) => new Date(a.abreisedatum) - new Date(b.abreisedatum));
    },

    showFlugstammdatenButton() {
      return (
        this.aufgabenKategorie === 'AnlageFlugstamm' || this.verlinkungenFields === basicVerlinkungenFields
      );
    },

    // Bestimmt, welche Tabellen-Spalten für die aktuelle Aufgabenkategorie angezeigt werden.
    verlinkungenFields() {
      if (this.isTerminplanungAufgabe) return fieldsTerminplanungAufgaben;
      if (this.aufgabenKategorie === 'UnverbindlichesFlugangebot')
        return fomUnverbindlichesFlugangebotVerlinkungenFields;
      if (this.aufgabenKategorie === 'VorabpruefungTicketBeiGruppe')
        return fieldsVorabpruefungTicketBeiGruppe;
      if (this.aufgabenKategorie === 'TicketingAnfrage') return TicketingAnfrageVerlinkungenFields;
      if (this.isFomAufgabe) return fomVerlinkungenFields;
      if (this.isRepruAufgabe) return repruAufgabenFields;
      if (this.isZvcAufgabe) return zvcVerlinkungenFields;
      if (this.aufgabenKategorie === 'ZusatzterminVorzeitigeGarantiePruefen') return fieldsZTVTGPruefen;

      if (
        this.isReleaseprozessAufgabe ||
        this.isMtzAufgabe ||
        RELEASEPROZESS_FIELDS_KATEGORIEN.includes(this.aufgabenKategorie)
      ) {
        return releaseprozessVerlinkungenFields;
      }

      if (this.aufgabenKategorie === 'AnlageHotelstamm' || this.aufgabenKategorie === 'ZusatzterminAnlegen') {
        return fieldsAnlageHotelstamm;
      }
      if (this.aufgabenKategorie === 'AnlageFlugstamm') return fieldsAnlageFlugstamm;
      if (this.aufgabenKategorie === 'GruppeneinkaufPruefen') return fieldsGruppeneinkaufPruefen;
      if (OPTIONSFRIST_KATEGORIEN.includes(this.aufgabenKategorie)) return fieldsOptionsfristErreicht;
      if (this.aufgabenKategorie === 'StopsaleSetzen') return fieldsStopsaleSetzen;
      if (this.aufgabenKategorie === 'TeilnehmerdokumentePruefen')
        return teilnehmerdokumenteVerlinkungenFields;
      if (KURZES_TKTL_KATEGORIEN.includes(this.aufgabenKategorie)) return kurzesTktlFields;
      if (this.aufgabenKategorie === 'MinMaxPaxPruefen') return minMaxPaxPruefenFields;

      return basicVerlinkungenFields;
    },

    joinedReiseterminkuerzel() {
      if (!this.reiseterminData) return '';
      return this.reiseterminData.map(rt => rt.reiseterminkuerzel).join(',');
    },

    isReleaseprozessAufgabe() {
      return this.getKategorienReleaseprozess
        .map(kategorie => kategorie.aufgabenKategorie)
        .includes(this.aufgabenKategorie);
    },

    isMtzAufgabe() {
      return this.aufgabenKategorie === 'MtzUnterschritten';
    },

    jumpToReleasepruefung() {
      return RELEASEPRUEFUNG_KATEGORIEN.includes(this.aufgabenKategorie);
    },

    isFomAufgabe() {
      return FOM_KATEGORIEN.includes(this.aufgabenKategorie);
    },

    jumpIntoReisetermindetailsFluegeTab() {
      return this.isFomAufgabe || this.aufgabenKategorie === 'VorabpruefungTicketBeiGruppe';
    },

    isZvcAufgabe() {
      return ZVC_KATEGORIEN.includes(this.aufgabenKategorie);
    },

    isTerminplanungAufgabe() {
      return TERMINPLANUNG_KATEGORIEN.includes(this.aufgabenKategorie);
    },
  },
  methods: {
    formatDateWithoutHours,
    releaseprozessIconsColors,

    getRequiredDokumente(gueltigeKonfiguration) {
      if (!gueltigeKonfiguration) return '';
      return Object.entries(DOKUMENT_FIELDS)
        .filter(([key]) => gueltigeKonfiguration[key] === true)
        .map(([, label]) => label)
        .join(', ');
    },

    getGruppeFlughaefen(item) {
      const gruppeneinkaeufe = this.getFilteredGruppeneinkaeufe(item, ['flughafenIataCode', 'gruppePnr']);
      return gruppeneinkaeufe.length > 0
        ? gruppeneinkaeufe.map(gruppe => `${gruppe.flughafenIataCode}(${gruppe.gruppePnr})`).join(', ')
        : '-';
    },

    getErsteGruppeFlughaefen(item) {
      const erste = this.getFilteredGruppeneinkaeufe(item, ['flughafenIataCode', 'gruppePnr'])[0];
      if (!erste) return '-';
      return `${erste.flughafenIataCode}{${erste.gruppePnr}}`;
    },

    getErsteGruppeGesamtpreis(item) {
      const erste = this.getFilteredGruppeneinkaeufe(item, ['gesamtpreisGruppeneinkauf'])[0];
      return erste?.gesamtpreisGruppeneinkauf ?? '-';
    },

    // Hilfsmethode: Filtert die Gruppeneinkaeufe eines Reisetermins so
    getFilteredGruppeneinkaeufe(item, requiredFields) {
      return (
        item.flugeinkauf?.gruppeneinkaeufe?.filter(gruppe => requiredFields.every(field => gruppe[field])) ||
        []
      );
    },

    rowClicked(item) {
      const base = `/#/reisetermine/${item.id}`;

      if (this.jumpToReleasepruefung || this.isReleaseprozessAufgabe) {
        window.open(`${base}/releasepruefung`, '_blank');
      } else if (this.isMtzAufgabe) {
        window.open(`${base}/`, '_blank');
      } else if (this.jumpIntoReisetermindetailsFluegeTab) {
        window.open(`${base}/?vorgangdetailstab=fluege&scrollToFlugdaten=true`, '_blank');
      } else if (this.aufgabenKategorie === 'TeilnehmendeOhneTransferplanung') {
        window.open(`${base}/releasepruefung?releasepruefungstab=transfer&scrollToFlugdaten=true`, '_blank');
      } else {
        window.open(base, '_blank');
      }
    },

    openFilteredView(path) {
      const reisekuerzel = [
        ...new Set(this.reiseterminData.map(item => item.reiseterminkuerzel.substring(0, 6))),
      ];
      const years = this.reiseterminData.map(item => new Date(item.abreisedatum).getFullYear());
      const minYear = Math.min(...years);
      const maxYear = Math.max(...years);
      window.open(
        `/#/${path}?reise=${reisekuerzel}&abreisedatumVon=${minYear}-01-01&abreisedatumBis=${maxYear}-12-31`,
        '_blank'
      );
    },

    openFilteredFlugstammdatenView() {
      this.openFilteredView('flugstammdaten');
    },

    openFilteredReiseterminplanungView() {
      this.openFilteredView('reisetermine/planung');
    },

    openTerminplanungView() {
      window.open(
        `/#/reisetermine/planung?reisetermine=${this.joinedReiseterminkuerzel}&collapse=true`,
        '_blank'
      );
    },

    translateEinkaufsartOptions,

    translateStatusGruppeOptions,

    inlandsflugEinkaufState(reisetermin) {
      const inlandsfluege = reisetermin?.metadata?.inlandsfluege;
      if (!inlandsfluege?.length) return null;

      const allSkr = inlandsfluege.every(f => f.einkauf === 'Skr');
      if (allSkr) return 'skr';

      const allDmc = inlandsfluege.every(f => f.einkauf === 'Dmc');
      if (allDmc) return 'dmc';

      const hasSkr = inlandsfluege.some(f => f.einkauf === 'Skr');
      const hasDmc = inlandsfluege.some(f => f.einkauf === 'Dmc');
      if (hasSkr && hasDmc) return 'mixed';

      return null;
    },

    getSymbol(code) {
      return currenciesJson[code]?.symbol;
    },

    // Warnung wenn mehr Pax bis Max als freie Zimmerplätze
    paxBisMaxVariant(item) {
      return item.paxBisMax > item.zimmerkontingentePersonenFrei ? 'yellow' : 'gray';
    },
    // Grün wenn noch erwartete Pax in die Zimmer passen, sonst rot
    nochErwartetePaxVariant(item) {
      return item.nochErwartetePax <= item.zimmerkontingentePersonenFrei ? 'green' : 'red';
    },
    // Wie nochErwartetePaxVariant, aber basierend auf dem Forecast statt der tatsächlichen Erwartung
    nochForecastPaxVariant(item) {
      return item.nochForecastPax <= item.zimmerkontingentePersonenFrei ? 'green' : 'red';
    },

    formatTransferSzenario(szenario) {
      if (szenario === 'T5_2' || szenario === 'T5_3') return szenario;
      return szenario?.substring(0, 2);
    },
  },
};
</script>
<style>
.custom-tooltip .tooltip-inner {
  max-height: 500px;
  overflow-y: auto;
  text-align: left;
}
</style>
<style scoped>
:deep(.b-table td) {
  vertical-align: middle;
}
</style>
